import React, { ReactElement } from "react";
import { currentLangIs } from "../../../helper/utils";
import IndexAccordionDe from "./IndexAccordionDe";
import IndexAccordionEn from "./IndexAccordionEn";

const IndexAccordion = (): ReactElement => {
  return (
    <>
      {currentLangIs("en") ? (
        <IndexAccordionEn />
      ) : (
        <IndexAccordionDe />
      )}
    </>
  );
};

export default IndexAccordion;
